import ResourceManager from "../../components/ResourceManager"
import { useCalendarEventMutations } from "../hooks/use-calendar-event-mutations"
import { ResourceType } from "../../components/ResourceManager/ResourceManager"
import { useI18n } from "../../hooks/use-i18n"
import { StringMap } from "../../types/common"
import { CalendarEventViewModel } from "../api/calendar-event"
import { CalendarEventTaskResponse } from "../api/calendar-event-response"

const EventTaskWidget = ({ calendarEvent, taskOptions, isTaskLoading }: EventTaskWidgetProps) => {
  const { updateTask } = useCalendarEventMutations()
  const translations = useTranslations(defaultTranslations)

  const taskResource: ResourceType[] = calendarEvent.task
    ? [{ id: calendarEvent.task.id, name: calendarEvent.task.title }]
    : []

  const onAddTask = (taskId: string) => {
    const task = taskOptions.find((t) => t.id === taskId)
    updateTask(calendarEvent.id, {
      id: task?.id || "",
      title: task?.name || "Untitled Task",
    } as CalendarEventTaskResponse)
  }

  const onRemoveTask = (taskId: string) => {
    updateTask(calendarEvent.id, null)
  }

  return (
    <ResourceManager
      title={translations.title}
      resourceOptions={taskOptions}
      resources={taskResource}
      canAddResource={calendarEvent.canUpdate && !isTaskLoading}
      canRemoveResource={calendarEvent.canUpdate && !isTaskLoading}
      onAddResource={onAddTask}
      onRemoveResource={onRemoveTask}
      emptyOptionsMessage={translations.emptyOptionsMessage}
      emptyResourcesMessage={translations.emptyResourcesMessage}
      isMultipleSelection={false}
    />
  )
}

const useTranslations = (defaults = defaultTranslations) => {
  const { translations: t } = useI18n("calendarEvent")
  const translations = (t?.taskWidget || {}) as StringMap

  const {
    title = defaults.title,
    emptyOptionsMessage = defaults.emptyOptionsMessage,
    emptyResourcesMessage = defaults.emptyResourcesMessage,
    updateErrorMessage = defaults.updateErrorMessage,
  } = translations

  return {
    title,
    emptyOptionsMessage,
    emptyResourcesMessage,
    updateErrorMessage,
  }
}

const defaultTranslations = {
  title: "Task",
  emptyOptionsMessage: "No tasks to connect this event",
  emptyResourcesMessage: "This event is not connected to any task",
  updateErrorMessage: "Failed to update task",
}

type EventTaskWidgetProps = {
  calendarEvent: CalendarEventViewModel
  taskOptions: ResourceType[]
  isTaskLoading?: boolean
}

export default EventTaskWidget
